import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";
import { Campaign } from "../../models/campaign.model";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";

let SelectPropertyFormComponent = {
    selector: "vcSelectPropertyForm",
    templateUrl:
        "/angular/components/group/select-property-form.component.html",
    bindings: {
        label: "=",
        properties: "=",
        selectedIndex: "=",
    },
    controller: class SelectPropertyFormController {
        // * bindings for typescript compiler *
        public selectedIndex: any;
        // ************************************
        public activeCampaign: Campaign;
        private dialog: DialogUtils;

        constructor(
            DialogUtils: DialogUtils,
            CampaignDataProvider: CampaignDataProvider
        ) {
            this.dialog = DialogUtils;
            this.activeCampaign = CampaignDataProvider.getActiveCampaign();
        }

        confirm(): void {
            if (this.activeCampaign && this.activeCampaign.localInfo) {
                this.activeCampaign.localInfo.selectedPropIndex =
                    this.selectedIndex;
                this.activeCampaign.saveLocalStorage();
            }
            this.dialog.hide(this.selectedIndex);
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("group")
    .component(
        SelectPropertyFormComponent.selector,
        SelectPropertyFormComponent
    );
